import React from 'react'

import '@loyal_template/order.css'

const OrderItem = props => (
  <div className='orders-item row'>
    <div className='col-12 px-3 order-item '>
      <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
        <div className='order-img col-auto txt-center pl-0 pr-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12'>
              <img
                src='https://via.placeholder.com/150'
                alt='Imagem do produto'
              />
            </div>
          </div>
        </div>

        <div className='order-product-info col mr-auto'>
          <div className='order-product-info row'>
            <div className='product-infos col-12 mx-0'>
              <div className='row'>
                <div className='col-auto'>
                  <i className='icon icon_check_circle color-success h4  d-inline-block' />
                </div>
                <div className='col py-half px-0'>
                  <strong className='txt-font-body py-half color-success txt-body'>
                    Entregue
                  </strong>
                </div>
              </div>

              <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android
                6.0, 4G câmera 12MP
              </h2>
              <div className='row mt-1 mx-0'>
                <div className='col py-half px-0 txt-subtitle'>
                  <p className='txt-subtitle'>
                    Valor: <strong>2.200 reales x 2 unidades</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Previsão de entrega: <strong>10/11/2018</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Fornecido e entregue por: <strong>Pontofrio.com</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='order-action pos-relative col-3 d-none d-md-inline-block txt-center'>
          <div className='row align-items-center h-100'>
            <button className='btn btn-sm'>Ver detalhes</button>
          </div>
        </div>
      </div>
    </div>
    <div className='col-12 px-3 order-item '>
      <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
        <div className='order-img col-auto txt-center pl-0 pr-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12'>
              <img
                src='https://via.placeholder.com/150'
                alt='Imagem do produto'
              />
            </div>
          </div>
        </div>

        <div className='order-product-info col mr-auto'>
          <div className='order-product-info row'>
            <div className='product-infos col-12 mx-0'>
              <div className='row'>
                <div className='col-auto'>
                  <i className='icon icon_truck color-warning h4  d-inline-block' aria-hidden='true' />
                </div>
                <div className='col py-half px-0'>
                  <strong className='txt-font-body py-half color-warning txt-body'>
                    Produto com dificuldade na entrega
                  </strong>
                </div>
              </div>

              <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android
                6.0, 4G câmera 12MP
              </h2>
              <div className='row mt-1 mx-0'>
                <div className='col py-half px-0 txt-subtitle'>
                  <p className='txt-subtitle'>
                    Valor: <strong>2.200 reales x 2 unidades</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Previsão de entrega: <strong>10/11/2018</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Fornecido e entregue por: <strong>Pontofrio.com</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='order-action pos-relative col-3 d-none d-md-inline-block txt-center'>
          <div className='row align-items-center h-100'>
            <button className='btn btn-sm'>Ver detalhes</button>
          </div>
        </div>
      </div>
    </div>
    <div className='col-12 px-3 order-item '>
      <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
        <div className='order-img col-auto txt-center pl-0 pr-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12'>
              <img
                src='https://via.placeholder.com/150'
                alt='Imagem do produto'
              />
            </div>
          </div>
        </div>

        <div className='order-product-info col mr-auto'>
          <div className='order-product-info row'>
            <div className='product-infos col-12 mx-0'>
              <div className='row'>
                <div className='col-auto'>
                  <i className='icon icon_truck color-success h4  d-inline-block' aria-hidden='true' />
                </div>
                <div className='col py-half px-0'>
                  <strong className='txt-font-body py-half color-success txt-body'>
                    Enviado para a transportadora
                  </strong>
                </div>
              </div>

              <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android
                6.0, 4G câmera 12MP
              </h2>
              <div className='row mt-1 mx-0'>
                <div className='col py-half px-0 txt-subtitle'>
                  <p className='txt-subtitle'>
                    Valor: <strong>2.200 reales x 2 unidades</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Previsão de entrega: <strong>10/11/2018</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Fornecido e entregue por: <strong>Pontofrio.com</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='order-action pos-relative col-3 d-none d-md-inline-block txt-center'>
          <div className='row align-items-center h-100'>
            <button className='btn btn-sm'>Ver detalhes</button>
          </div>
        </div>
      </div>
    </div>
    <div className='col-12 px-3 order-item '>
      <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
        <div className='order-img col-auto txt-center pl-0 pr-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12'>
              <img
                src='https://via.placeholder.com/150'
                alt='Imagem do produto'
              />
            </div>
          </div>
        </div>

        <div className='order-product-info col mr-auto'>
          <div className='order-product-info row'>
            <div className='product-infos col-12 mx-0'>
              <div className='row'>
                <div className='col-auto'>
                  <i className='icon icon_close_circle color-error h4  d-inline-block' />
                </div>
                <div className='col py-half px-0'>
                  <strong className='txt-font-body py-half color-error txt-body'>
                    Cancelado
                  </strong>
                </div>
              </div>

              <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android
                6.0, 4G câmera 12MP
              </h2>
              <div className='row mt-1 mx-0'>
                <div className='col py-half px-0 txt-subtitle'>
                  <p className='txt-subtitle'>
                    Valor: <strong>2.200 reales x 2 unidades</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Previsão de entrega: <strong>10/11/2018</strong>
                  </p>
                  <p className='txt-subtitle'>
                    Fornecido e entregue por: <strong>Pontofrio.com</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='order-action pos-relative col-3 d-none d-md-inline-block txt-center'>
          <div className='row align-items-center h-100'>
            <button className='btn btn-sm'>Ver detalhes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default OrderItem



// WEBPACK FOOTER //
// ./src/features/User/Orders/OrderItem.js